import React, { useEffect } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

const StoreProgressComponent = props => {
  useEffect(() => {
    // Prepare data
    const mergedData = props.totalPricesPerStore.map(totalEntry => {
      const updatedEntry = props.updatedPricesPerStore.find(
        entry => entry.card_price_store === totalEntry.card_price_store,
      );

      return {
        store: totalEntry.card_price_store,
        totalPrices: parseInt(totalEntry.count, 10),
        updatedPrices: updatedEntry ? parseInt(updatedEntry.count, 10) : 0,
        remainingPrices:
          parseInt(totalEntry.count, 10) -
          (updatedEntry ? parseInt(updatedEntry.count, 10) : 0),
      };
    });

    // Create chart instance
    const chart = am4core.create('chartdiv', am4charts.XYChart);
    chart.data = mergedData;

    // Create category axis (stores)
    const categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'store';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.inversed = true;
    categoryAxis.renderer.labels.template.fill = am4core.color('#FFFFFF'); // White text for labels
    categoryAxis.renderer.minGridDistance = 20; // Show all store labels

    // Create value axis (prices)
    const valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.renderer.labels.template.fill = am4core.color('#FFFFFF'); // White text for labels

    // Create series for updated prices
    const updatedSeries = chart.series.push(new am4charts.ColumnSeries());
    updatedSeries.dataFields.valueX = 'updatedPrices';
    updatedSeries.dataFields.categoryY = 'store';
    updatedSeries.name = 'Updated Prices';
    updatedSeries.stacked = true;
    updatedSeries.columns.template.fill = am4core.color('#67b7dc'); // Blue color
    updatedSeries.columns.template.tooltipText = '{name}: {valueX}'; // Tooltip for updated prices

    // Create series for remaining prices
    const remainingSeries = chart.series.push(new am4charts.ColumnSeries());
    remainingSeries.dataFields.valueX = 'remainingPrices';
    remainingSeries.dataFields.categoryY = 'store';
    remainingSeries.name = 'Remaining Prices';
    remainingSeries.stacked = true;
    remainingSeries.columns.template.fill = am4core.color('#f3d13f'); // Yellow color
    remainingSeries.columns.template.tooltipText = '{name}: {valueX}'; // Tooltip for remaining prices

    // Add legend
    chart.legend = new am4charts.Legend();
    chart.legend.labels.template.fill = am4core.color('#FFFFFF');

    // Cleanup on unmount
    return () => {
      chart.dispose();
    };
  }, [props.totalPricesPerStore, props.updatedPricesPerStore]); // Rerun if props change

  const storeCount = props.totalPricesPerStore
    ? props.totalPricesPerStore.length
    : 0;
  const chartHeight = Math.max(500, storeCount * 40);

  return (
    <div
      id="chartdiv"
      style={{ width: '100%', height: `${chartHeight}px` }}></div>
  );
};

export default StoreProgressComponent;
